export const createDataTree = (dataset) => {
  dataset = dataset.map((_d,idx) => {
    _d.key = idx + 1
    _d.title = _d.value
    _d.value = _d._id
    return _d
  })
  const hashTable = Object.create(null);
  dataset.forEach(aData => {
    if (aData.level === 3) {
      hashTable[aData._id] = { ...aData } 
    } else {
      hashTable[aData._id] = { ...aData, children: [] } 
    }
  });
  const dataTree = [];
  dataset.forEach(aData => {
    if (aData.parentId) {
      hashTable[aData.parentId].children.push(hashTable[aData._id]);
    } else {
      dataTree.push(hashTable[aData._id]);
    }
  });
  return dataTree;
};


// WEBPACK FOOTER //
// ./src/components/three-ps/functions.js